<template>
  <div class="h-screen">
    <div class="backdrop"></div>
	  <confirmation-modal v-if="showConfirmationModal"
	                      @cancel="showConfirmationModal = false"
	                      @confirm="sendNotification"
	                      :modal-header-text="'Czy na pewno chcesz wysłać wiadomość?'"
	                      buttons-on-edges
	                      :cancel-button-text="'ANULUJ'"
	                      :confirm-button-text="'WYŚLIJ'"
	                      :modal-body-text="'Wiadomość zostanie wysłana natychmiast'" />
    <confirmation-modal v-if="showExitConfirmationModal"
                        @cancel="showExitConfirmationModal = false"
                        @confirm="$emit('close')"
                        :modal-header-text="'Czy na pewno chcesz opuścić okno wysyłania powiadomienia?'"
                        :cancel-button-text="'Zostań'"
                        :confirm-button-text="'Opuść'"
                        :modal-body-text="'Twoje dane zostaną utracone!'"/>
    <div v-click-outside="clickOutside"
         class="fixed left-0 z-[999] bg-zt-normal rounded-zt shadow-zt w-full overflow-hidden h-[calc(100vh-24px)]
                xl:h-fit xl:max-h-[70%] xl:bottom-auto xl:top-1/2 xl:-translate-y-1/2 xl:w-fit xl:left-1/2 xl:-translate-x-1/2"
         :class="isHeaderVisible ? 'top-0' : 'top-16'">
      <div class="flex flex-nowrap items-center mx-5 my-[14px] relative
                  after:content-[''] after:h-[1px] after:bg-[#313A44] after:absolute after:w-[120%] after:-bottom-[14px]
                  after:-mx-5">
        <span class="text-[16px] font-semibold">Wysyłanie powiadomienia</span>
      </div>
      <div class="x-close-modal" @click.stop="$emit('close')"></div>
      <div class="px-4 pt-2 pb-4 flex flex-col h-[calc(100%-84px)]">
        <div class="mb-4 text-sm">
          Odbiorca:
          <span v-if="Number(recipientId) !== 0" class="font-medium">{{ recipientName }}</span>
          <span v-else class="font-medium text-zt-red">Wszyscy użytkownicy</span>
        </div>
        <div class="mb-4">
          <label for="notification-link">Tytuł</label>
          <input type="text" v-model="title" id="notification-link" class="h-8" maxlength="200">
        </div>
        <div class="mb-2">
          <label for="notification-content">Treść powiadomienia</label>
          <TinyMCE id="notification-content"
                   v-model="content"
                   :init="{
                      license_key: 'gpl',
                      height: 250,
                      menubar: false,
                      block_unsupported_drop: false,
                      content_css: false,
                      skin: false,
                      content_style: 'body { font-family:Poppins,Arial,sans-serif; font-size:16px }',
                      plugins: [
                        'autolink', 'lists', 'advlist', 'link', 'charmap', 'preview', 'anchor',
                        'visualblocks', 'code', 'fullscreen', 'table', 'code', 'wordcount'
                      ],
                      toolbar:
                        'undo redo | link | formatselect | bold italic underline backcolor forecolor | \
                          fontsize | alignleft aligncenter alignright alignjustify | \
                          bullist numlist | code | removeformat '
                    }" />
        </div>
        <div>
          <button class="zt-button mx-auto block" @click="showConfirmationModal = true">WYŚLIJ</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils_mixin from '../../mixins/utils_mixin';
import { Notice } from '../../../assets/js/Notice';
import ConfirmationModal from "./ConfirmationModal.vue";
import TinyMCE from '../TinyMCE.vue';

export default {
  name: 'SendNotificationModal',
	components: { TinyMCE, ConfirmationModal },
  props: ['recipientId', 'recipientName'],
  emits: ['close'],
  mixins: [utils_mixin],
  data() {
    return {
      clickOutside: {
        handler: (e) => {
          if (!e.target.closest('.tox') && !e.target.closest('.preventCloseParentModal')) {
            this.openExitConfirmationModal();
          }
        },
        events: ['touchend', 'mousedown'],
      },
      content: '',
      title: 'Ważne ogłoszenie!',
	    showConfirmationModal: false,
      showExitConfirmationModal: false,
      isHeaderVisible: true
    }
  },
  created() {
    this.blockScrolling();
    this.checkHeaderVisibility();
  },
  unmounted() {
    this.unblockScrolling();
  },
  methods: {
    sendNotification() {
      this.sendAdminNotification(this.recipientId, this.content, this.title).then(() => {
        this.addInternalNotification(new Notice().setContent('Wysłano powiadomienie!'));
      });

      this.$emit('close');
    },
    checkHeaderVisibility() {
      const header = document.getElementById('main-header');
      const transformValue = header.style.transform;
      this.isHeaderVisible = (transformValue === 'translateY(0px)' || transformValue === '');
    },
    openExitConfirmationModal() {
      if (this.content === '' && this.title === 'Ważne ogłoszenie!') {
        this.$emit('close');
      } else {
        this.showExitConfirmationModal = true;
      }
    },
  }
};
</script>


